import { Guid } from 'guid-typescript';


export enum AttachmentType {
    Tmp = 1,
    MyFolder = 2,
    Question = 3,
    Answer = 4,
    Chat = 5,
    Wall = 6,
    Choice = 7,
    PublicQuestion = 8,
    PublicChoice = 9,
    Subscription = 10,
    QuestionChoiceGroup = 11,
    SchoolBag = 12,
    UserProfile = 13,
    Mailbox = 14,
    Post = 15,
    Comment = 16,
    WeeklyPlan = 17,
    Behaviour = 18,
    SchoolBagFolderImage = 19,
    SchoolBagFileImage = 20,

    Homework = 39,
    HomeworkCorrectAnswer = 40,
    HomeworkStudentAnswer = 41
}

export class AttachmentFolder {
    id: Guid;
    userId: Guid;
    folderName: string;
    parentFolderId: Guid;
}

export class Attachment {
    id: Guid;
    fileName: string;
    attachmentName: string;
    uploadDate: Date;
    module: AttachmentType;
    contentLength: number;
    contentType: string;
    userId: Guid;
    subscriptionId: Guid;//subscriptionId/attachmentType/uploadDate.Year/Month/Day/fileName
    serviceId?: Guid;
    folderId?: Guid;
    thumbnails?: Array<AttachmentThumbnail>;
    type?: string;
    userFileName?: string;
    fullPath?: string;
    fileUrl?: string;
    thumbnailPath?: string;
    caption?: string;
}

export class AttachmentThumbnail {
    id: Guid;
    attachmentId: Guid;
    fileName: string;
    Width: number;
    Height: number;
    fileUrl?: string;
}

export class AttachmentFilter {
    constructor() {
        this.fileType = 'image|video|audio|document';
        this.fileSize = 1024 * 1024 * 10;
    }
    multiFiles?: boolean;
    fileType?: string;//'image|video|audio|document'
    fileSize?: number;
    attachmentType?: AttachmentType;
    preview?: boolean;
}
